import React from 'react';
import { useTranslation } from 'react-i18next';
// import { useNavigate } from 'react-router';
import Image from '../../../assets/images/Content-bro.png';
// import Button from '../../../shared/component/Button';

function NoSearchResultsFound() {
  const { t } = useTranslation();
  // const navigate = useNavigate();
  return (
    <div className="template-main-container">
      <div className="sub-container">
        <div className="no-time-plan-data">
          <img
            alt="Empty state"
            src={Image}
            loading="lazy"
            role="presentation"
          />
        </div>
        <div className="no-data-message">
          <div className="message-title">
            <span className="message-header">{t('oops no result found')}</span>
            <span className="message-line">
              {t('please try another search')}
            </span>
            {/* <div className="form-button">
              <Button
                label={t('save')}
                click={() => {
                  navigate('/admin/templates');
                }}
                classes="success-button"
              />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default NoSearchResultsFound;
